import { Link, useNavigate } from "react-router-dom";
import { studentIdsForAccount } from "../domain/auth";
import { gradeLabel } from "../domain/data";
import { runtimeFromBrowser, sampleToolsEnabled } from "../domain/env";
import { useAuth } from "../state/AuthProvider";
import { useLocale } from "../state/i18n";
import { useStudents } from "../state/students";
import { PrototypeBanner, PublicNav } from "../components/ui";

export function FamilyHome() {
  const navigate = useNavigate();
  const { account, loading } = useAuth();
  const { studentsByIds } = useStudents();
  const { t } = useLocale();
  const sampleTools = sampleToolsEnabled(runtimeFromBrowser().name);
  const kids =
    account?.role === "parent" ? studentsByIds(studentIdsForAccount(account)) : [];

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <PublicNav />
        <p className="meta">{t("family.meta")}</p>
        <h1>{t("family.title")}</h1>
        <p className="lede">{t("family.lede")}</p>

        {loading ? (
          <div className="wire dashed">
            <p className="anno" style={{ margin: "0.5rem 0 0" }}>
              Loading household...
            </p>
          </div>
        ) : account?.role !== "parent" ? (
          <div className="wire dashed">
            <div className="meta">{t("family.empty")}</div>
            <p style={{ margin: "0.5rem 0 0" }}>{t("signup.lede")}</p>
            <div className="actions">
              <Link className="btn" to="/signup">
                {t("signup.submit")}
              </Link>
            </div>
          </div>
        ) : kids.length === 0 ? (
          <div className="wire dashed">
            <div className="meta">{t("family.empty")}</div>
            <p style={{ margin: "0.5rem 0 0" }}>{t("family.emptyBody")}</p>
          </div>
        ) : (
          <ul className="list-plain">
            {kids.map((student) => (
              <li key={student.id}>
                <Link to={`/student/${student.id}`}>
                  <div className="row">
                    <div>
                      <div className="title">
                        <strong>
                          {student.given} {student.family}
                        </strong>
                      </div>
                      <div className="anno">
                        {student.school} · {t("family.grade", { grade: gradeLabel(student.grade) })}
                      </div>
                    </div>
                    <div className="tag muted">{t("student.landing")}</div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}

        <div className="actions">
          <Link className="btn" to="/register">
            {t("family.add")}
          </Link>
        </div>
        {sampleTools && account?.role === "parent" ? (
          <div className="qa-sample">
            <p className="qa-sample-tag">{t("sample.testOnly")}</p>
            <button
              type="button"
              className="btn ghost"
              onClick={() => navigate("/register", { state: { fillSample: true } })}
            >
              {t("family.sample")}
            </button>
          </div>
        ) : null}
      </main>
    </div>
  );
}
